export default __webpack_public_path__ + "static/media/broadcast-transactional-proposal.952444aa.svg";